<template>
  <div class="order">
    <div class="order_head">
      <ul>
        <li
          v-for="(tab, index) in tabsCard.tabs"
          :key="index"
          :class="{ active: tabsCard.num === index }"
          @click="tab(index)"
        >
          <span>{{ tab }}</span>
        </li>
      </ul>
      <div class="barSty" v-if="isEdit">
        <span style="margin-right: 10px" @click="cancelEdit(false)">取消</span>
        <span @click="cancelEdit(true)">删除</span>
      </div>
      <span v-else @click="changeEditStatus">编辑</span>
    </div>
    <div class="main">
      <el-checkbox-group v-model="checkList">
        <div class="orderItem" v-for="(item, index) in showData" :key="index">
          <div class="titleImg">
            <div class="order-img" @click="jumpToVideo(item.videoInfo && item.videoInfo.status, item.videoInfo && item.videoInfo.id)">
              <img v-if="item.videoInfo" :src="item.videoInfo.horizontalImage" alt="" />
              <img v-else src="/img/no_data.043dd92a.png" alt="" />
            </div>
            <div class="layer" v-show="isEdit">
              <el-checkbox :label="item.id"></el-checkbox>
            </div>
          </div>
          <div class="titleImg_right">
            <div class="titleImg_top">
              <h4>
                <span>订单编号:{{ item.outTradeNo }}</span>
                <span class="normalSty">￥{{ item.money }}</span>
              </h4>
              <p>
                <span v-if="item.videoInfo">购买视频：{{ item.videoInfo.videoName }}</span>
                <span v-else>
                  <span v-if="item.memberType">{{ item.memberType.typeName }}充值</span>
                </span>
              </p>
            </div>
            <p><span>{{ item.createdTime | formatDate }}</span></p>
          </div>
        </div>
      </el-checkbox-group>
      <div class="no-data" v-if="isShowNoContent">
        <img src="/img/no_data.043dd92a.png" alt="" style="width: 200px" />
      </div>
    </div>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'

function formatDateStr(timestamp) {
  const date = new Date(timestamp)
  const y = date.getFullYear()
  const M = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  const h = String(date.getHours()).padStart(2, '0')
  const m = String(date.getMinutes()).padStart(2, '0')
  const s = String(date.getSeconds()).padStart(2, '0')
  return `${y}-${M}-${d} ${h}:${m}:${s}`
}

export default {
  name: 'OrderManagement',
  filters: {
    formatDate(val) {
      if (!val) return ''
      return formatDateStr(val)
    }
  },
  data() {
    const now = new Date()
    const y = now.getFullYear()
    const M = now.getMonth()
    const d = now.getDate()
    const todayBegin = new Date(y, M, d, 0, 0, 0).getTime()
    const todayEnd = new Date(y, M, d, 23, 59, 59).getTime()
    const lastWeek = new Date(y, M, d - 6, 0, 0, 0).getTime()
    const lastMonth = new Date(y, M, d - 30, 0, 0, 0).getTime()

    return {
      tabsCard: { tabs: ['今天', '最近一周', '最近一月', '全部'], num: 0 },
      showData: [],
      isShowNoContent: false,
      isEdit: false,
      checkList: [],
      todayBeginTime: todayBegin,
      todayEndTime: todayEnd,
      lastWeekTime: lastWeek,
      lastMonthTime: lastMonth
    }
  },
  mounted() {
    this.tab(0)
  },
  methods: {
    tab(index) {
      this.tabsCard.num = index
      let params
      switch (index) {
        case 0:
          params = { beginTime: this.todayBeginTime, endTime: this.todayEndTime, orderByType: 'DESC' }
          break
        case 1:
          params = { beginTime: this.lastWeekTime, endTime: this.todayEndTime, orderByType: 'DESC' }
          break
        case 2:
          params = { beginTime: this.lastMonthTime, endTime: this.todayEndTime, orderByType: 'DESC' }
          break
        default:
          params = { orderByType: 'DESC' }
      }
      this.orderFn(params)
    },
    orderFn(params) {
      this.$axios({
        method: 'get',
        url: '/realNet/order/getOrders',
        headers: { token: getToken() },
        params
      }).then(res => {
        const content = res.data.result.content || []
        this.showData = content
        this.isShowNoContent = content.length === 0
      })
    },
    changeEditStatus() {
      this.isEdit = true
    },
    cancelEdit(isDel) {
      if (isDel) {
        if (this.checkList.length === 0) {
          this.$message.warning('请选择要删除的数据')
          return
        }
        this.delCollect()
      } else {
        this.isEdit = false
        this.checkList = []
      }
    },
    delCollect() {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios({
          method: 'delete',
          url: '/realNet/order/delete',
          headers: { token: getToken() },
          data: { orderIds: this.checkList.join(',') }
        }).then(() => {
          this.$message({ showClose: true, message: '删除成功', type: 'success', duration: 1000 })
          this.isEdit = false
          this.checkList = []
          this.tab(this.tabsCard.num)
        })
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消删除' })
      })
    },
    jumpToVideo(status, id) {
      if (status === 1) {
        this.$router.push({ path: '/tvplay-page', query: { contentId: id } })
      } else if (status === 2) {
        this.$message.warning('此视频已下架，请观看其他视频')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.order {
  width: 930px;

  .order_head {
    width: 100%;
    height: 41px;
    border: 1px solid #eaeced;
    padding: 0 40px;
    margin-bottom: 30px;
    background-color: #f9f9f9;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;

    ul {
      width: 70%;
      height: 100%;
      padding: 0;
      display: flex;

      li {
        height: 100%;
        padding: 0 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        position: relative;
        list-style: none;

        span { cursor: pointer; }

        &.active {
          font-weight: 700;

          &::before {
            position: absolute;
            left: 50%;
            margin-left: -15px;
            bottom: -2px;
            content: "";
            background-color: #3bc0d0;
            width: 35px;
            height: 3px;
          }
        }
      }
    }

    .barSty,
    > span {
      font-size: 14px;
      color: #2cb5c5;
      cursor: pointer;
    }
  }

  .main {
    width: 100%;

    .orderItem {
      width: 930px;
      height: 135px;
      margin-bottom: 30px;
      display: flex;

      .titleImg {
        position: relative;
        width: 240px;
        height: 135px;
        margin-right: 30px;
        background-color: #ccc;
        cursor: pointer;

        .order-img > img {
          width: 240px;
          height: 135px;
        }

        .layer {
          position: absolute;
          left: 0;
          top: 0;
          z-index: 10;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.3);
        }
      }

      .titleImg_right {
        width: 615px;
        height: 100%;
        padding: 10px 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        box-sizing: border-box;

        .titleImg_top {
          width: 100%;
          height: 60px;

          h4 {
            width: 100%;
            height: 25px;
            margin-bottom: 16px;
            display: flex;
            justify-content: space-between;
            font-size: 20px;

            .normalSty {
              color: #666;
              font-weight: 400;
            }
          }

          p {
            font-size: 16px;
            color: #888;
          }
        }

        > p {
          font-size: 16px;
          color: #888;
        }
      }
    }

    .no-data {
      text-align: center;
    }
  }
}
</style>
